import classNames from 'classnames';
import { AccountVerificationStatus, Icon } from 'components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProperty, usePublicAccount } from 'state';
import { verificationStatusTypes } from 'config/types';
import { SearchSettings, InventoryManage, CausesManage } from './components';
import {
  TitledBlock,
  Button,
  FlexContainer,
  Txt,
  ToDoHeading,
} from 'components';
import { useNavigationCallback } from 'hooks';
import styles from './PropertyManageScreen.module.scss';

/**
 * PropertyManageScreen
 *
 * @return {JSX.Element}
 */
const PropertyManageScreen = ({ className }) => {
  const property = useProperty();
  const publicAccount = usePublicAccount();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const highlight = searchParams.get('highlight');

  const {
    id: propertyUid,
    data: { standards },
  } = property;

  const { navigateToAndBackHere } = useNavigationCallback();

  const handleEdit = () =>
    navigateToAndBackHere(`/properties/${propertyUid}/edit`);

  const handleToDo = () => navigate(`/properties/${propertyUid}/todo`);

  const todoItemsStatus = [
    standards.eicrUrl,
    standards.epcUrl,
    standards.gscUrl,
    standards.smokeAlarmsChecked,
  ];

  const todoItemsDone = todoItemsStatus.filter(Boolean);

  return (
    <FlexContainer
      className={classNames(
        styles.PropertyManageScreen,
        className,
        `${PropertyManageScreen.displayName}`
      )}
      column
      gap
    >
      <TitledBlock>
        <ToDoHeading
          onClick={handleToDo}
          title2="Tasks"
          description2="Here you can manage certificates for this property and make this property legally compliant."
          completed={todoItemsDone.length}
          completedOf={todoItemsStatus.length}
          noDivider
          black
        />
      </TitledBlock>
      <Button big onClick={handleEdit}>
        <FlexContainer spaceBetween alignCenter flex>
          <Txt xx>Edit property</Txt>
          <Icon name="edit" />
        </FlexContainer>
      </Button>
      <TitledBlock title="Search">
        {publicAccount.data.verificationStatus ===
        verificationStatusTypes.VERIFIED ? (
          <SearchSettings highlight={highlight === 'tenants'} />
        ) : (
          <AccountVerificationStatus />
        )}
      </TitledBlock>
      <TitledBlock title="Inventory">
        <InventoryManage highlight={highlight === 'inventory'} />
      </TitledBlock>
      <TitledBlock title="Causes">
        <CausesManage />
      </TitledBlock>
    </FlexContainer>
  );
};

PropertyManageScreen.displayName = 'PropertyManageScreen';

export default PropertyManageScreen;
